import { registerLanguage } from '../_.contribution.js';

registerLanguage({
  id: "redis",
  extensions: [".redis"],
  aliases: ["redis"],
  loader: () => import('./redis.js')
});
